const MuiFormLabel = {
  styleOverrides: {
    root: {
      opacity: 0.4,
    },
  },
};

export default MuiFormLabel;
